import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Auth.css';
import { AuthContext } from '../context/AuthContext';
import { useContext } from 'react';
import './signin.css';
import BASE_URL from '../context/AppConfig';



const Signin = () => {
  const {login, setIsAuthenticated} = useContext(AuthContext);
   
  const [formData, setFormData] = useState({ username: '', password: '' });
  
  
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${BASE_URL}/signin/`, formData);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('refresh', response.data.refresh);
      localStorage.setItem("user", JSON.stringify(response.data.user));
      setIsAuthenticated(true);
      setUser(response.data.user); 
      toast('Signin successful! Welcome back.');
      console.log('login successfully');
      console.log(response.data.user);
      if(response.data.user.is_superuser){
        navigate('/admin'); // Redirect to admin dashboard if user is admin
      }
      else{
        navigate('/'); // Redirect to home if user is not admin
      }
      
      
      
      
    } catch (error) {
      setError('Invalid credentials. Please try again.');
      console.log('login failed');
        
    }

    

    console.log(user);
  };

  

  const handleGoogleSuccess = (credentialResponse) => {
    axios.post(`${BASE_URL}/google-login/`, { token: credentialResponse.credential })
      .then(response => {
        localStorage.setItem('token', response.data.token);
        navigate('/');
      })
      .catch(error => console.error('Google login failed:', error));
  };

  return (
    <div className="auth-container">
      <h2>Sign In</h2>
      <img src='img/loginicon.png' style = {{height: "150px", width: "150px", borderRadius: "50%"}}/>
      {(error ? (<p className='error-message'>{error}</p>) : '')}
      
      <form onSubmit={handleSubmit}>
        <input name="username" placeholder="Username" value={formData.username} onChange={handleChange} required />
        <input name="password" type="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
        <button type="submit">Sign In</button>
      </form>
      <p>Don't have an account? <a href="/signup" className='text-decoration-none create'>Create Now</a></p>
      <GoogleOAuthProvider clientId="756444366733-qpto08a8r9cpd0gf1vvhsdr6droka55a.apps.googleusercontent.com">
        <GoogleLogin onSuccess={handleGoogleSuccess} onError={() => console.log('Login Failed')} />
      </GoogleOAuthProvider>
    </div>
  );
};

export default Signin;
